module.exports = __webpack_public_path__ + "img/ontag-no-text.adb0817c.svg";